import React from "react";
import PopularCollection from "../../../components/_home/PopularCollection/PopularCollection";
import { popular } from "../../../mock/popular";
import styles from "./Public.module.scss";

const Public = () => {
  return (
    <div className={styles.container}>
      {popular.map((i) => (
        <PopularCollection
          key={i.id}
          name={i.name}
          creator={i.creator}
          collectionImage={i.collectionImg}
          images={i.images}
          total={i.total}
        />
      ))}
    </div>
  );
};

export default Public;
